import React from 'react'
import Currency from '../../components/currency'
import { backendUrl } from '../../constants'
import AttachmentList from './AttachmentList'
import { useSelector } from 'react-redux';

export default function PayoutDetailComponent({ step, isAdvisor }) {
    const { quotationDetail } = useSelector(state => state.stripe);
    return (
        <div>
            {step === 1 &&
                <>
                    <div className="payoutHeader mb-3">
                        <div
                            className="user_profile business-image hasLogo hasLogoPay" style={{
                                backgroundImage: `url(${quotationDetail?.company && quotationDetail?.company?.logo
                                    ? backendUrl + quotationDetail?.company?.logo
                                    : "/assets/img/Frame1.svg"
                                    })`
                            }} />
                        <div>
                            <h6 className="mb-0">{quotationDetail?.company?.companyName}</h6>
                            {quotationDetail?.company?.isAdvisor &&
                                <small>
                                    Advisor
                                </small>
                            }
                        </div>
                    </div>

                    {/* Plan Info */}
                    {/* {!quotationDetail?.company?.isDefault &&
                        <div className="infoRow">
                            <p className="leftText">Company name</p>
                            <p className="rightText">{quotationDetail?.company?.companyName}</p>
                        </div>
                    } */}
                </>
            }
            <div className="infoRow">
                <p className="leftText">Title</p>
                <p className="rightText">{quotationDetail?.name}</p>
            </div>

            <div className="infoRow">
                <p className="leftText">Description</p>
                <p className="rightText">{quotationDetail?.targetAudience}</p>
            </div>
            {quotationDetail?.attachment?.length > 0 &&
                <div className="infoRowNew">
                    <p className="leftText">Attachment</p>
                    <div className="infoRow infoRowAttachment">
                        <AttachmentList isAdvisor={isAdvisor} planPreview={quotationDetail} />
                    </div>
                </div>
            }

        </div>
    )
}
